<template>
    <SmallButton
        class="EditButton"
        :class="{ editable: editable }"
        :border-color="editable ? 'white' : 'white'"
        :button-hover-behaviour="editable ? 'gold' : 'gold'"
        :icon="editable ? ['fas', 'times'] : ['fas', 'pen']"
        @click="$emit('click', $event)"
    >
      {{ editable ? cancelLabel : editLabel }}
    </SmallButton>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faPen, faTimes } from '@fortawesome/free-solid-svg-icons'
import SmallButton from '@/components/input/SmallButton.vue'

library.add(faPen, faTimes)

export default {
  name: 'EditButton',
  components: {
    SmallButton,
  },
  props: {
    editLabel: {
      type: String,
      default: 'Edytuj',
    },
    cancelLabel: {
      type: String,
      default: 'Anuluj',
    },
    editable: {
      type: Boolean,
      required: true,
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "@/assets/scss/_variables.scss";

    // Mobile style
    @media (max-width: $phone-max-width) {
        .EditButton.hasIcon {
            width: 34px;
            height: 34px;
            padding: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: center;

            &.editable {
                font-size: 2em;
            }
        }
    }
</style>
